/**
 * Is value just string of decimal numbers
 */
export function stripCharacters(text: string, charactersToRemove: string[]) {
  charactersToRemove.forEach((skipCharacter) => {
    text = text.replaceAll(skipCharacter, '')
  })

  return text
}
